import { Route, Routes } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import { useSelector } from './hooks/useSelector'
import ListScreen from './screens/ListScreen'
import LoginScreen from './screens/LoginScreen'
import { isLoggedIn } from './state/user'

export const Router = () => {
    const loggedIn = useSelector(isLoggedIn)
    return (
        <BrowserRouter>
            <Routes>
                {loggedIn ? (
                    <>
                        <Route
                            path="/"
                            element={<ListScreen />}
                        />
                    </>
                ) : (
                    <Route
                        path="*"
                        element={<LoginScreen />}
                    />
                )}
            </Routes>
        </BrowserRouter>
    )
}
